
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/brokers/landing",
      function () {
        return require("private-next-pages/brokers/landing/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/brokers/landing"])
      });
    }
  